import Immutable = require('immutable')
import React = require('react')

import { Confirmation } from './Confirmation'
import {
    ADDRESS_FORM_STEP,
    AddressFormData,
    DetailsFormData,
    EmailQuoteData,
    IConfiguration,
    ISSUES_INDEX,
    IWizard,
    StoreQuoteData,
    StoreWizardData,
    QUOTE_STEP,
    CAPACITY_INDEX,
    EQuoteType,
    CONFIRMATION_STEP,
    TRANSFER_DETAILS,
} from './models'
import { Navigation } from './Navigation'
import { Question } from './Question'
import { calculateQuoteAmount } from './quoting'
import { AsyncPost, AsyncPostStatus, filterConfigurations, getTicketText, userChoicesAsDictionary } from './utils'

declare var Swiper, ga, window, $;

interface Properties {
    data: IWizard
    quoteRequestsFeedUrl: string    // Url of the Google Sheet feed for quote requests
    repairRequestsFeedUrl: string   // Url of the Google Sheet feed for repair requests
}

interface Callbacks {
}

interface Props extends Properties, Callbacks {}

interface State {
    currentQuestion: number
    userChoices: string[]
    isSubmitted: boolean
    postData: AsyncPost<any,any>
    detailsData: AsyncPost<DetailsFormData, string>
    addressData: AsyncPost<AddressFormData, any>
    sendQuoteByEmail: AsyncPost<StoreQuoteData, any>
    configurations: IConfiguration[]                // Available configurations at each step (filtered as going through)
    quote: number
    quoteNumber?: string
}

export class Wizard extends React.Component<Props, State> {

    swiper : any;

    constructor(props: Props) {
        super(props);
        this.state = {
            currentQuestion: 0,
            userChoices: [],
            configurations: props.data.configurations,
            isSubmitted: false,
            postData: {status: AsyncPostStatus.NONE, data: null},
            detailsData: {status: AsyncPostStatus.NONE, data: null},
            addressData: {status: AsyncPostStatus.NONE, data: null},
            sendQuoteByEmail: {status: AsyncPostStatus.NONE, data: null},
            quote: null
        }
    }

    componentDidMount() {
        this.swiper = new Swiper(this.refs['swiper'], {
            speed: 300,
            //spaceBetween: 100,
            //allowSwipeToNext: false
            //noSwiping: true
            //allowSwipeToPrev: false
            /*onSlideChangeStart: (swiper) => {
                this.setState({
                    currentQuestion: swiper.activeIndex,
                    userChoices: Immutable.List(this.state.userChoices).take(swiper.activeIndex).toJS()
                });
            }*/
        });
        this.swiper.lockSwipes();

        this.trackWizardPageView(this.state.currentQuestion);
    }

    componentWillUpdate(nextProps: Props, nextState: State) {
        if (this.state.currentQuestion !== nextState.currentQuestion) {
            this.trackWizardPageView(nextState.currentQuestion);
        }
    }

    trackWizardPageView(questionIndex: number) {

        var question = this.props.data.questions[questionIndex];
        var name = question ? question.name : 'Confirmation';

        ga('set', {
            page: 'wizard/' + (questionIndex+1) + '-' + name,
            title: 'Wizard - ' + name
        });
        ga('send', 'pageview');
    }

    private trackConversion() {
        window.goog_report_conversion("jjjCCI7n6W0Q1Lad3wM");
    }

    handleChoice(choice : string) {
        var newUserChoices =  Immutable.List(this.state.userChoices).set(this.state.currentQuestion, choice).toArray();
        var currentQuestion = this.state.currentQuestion;

        var quote = this.state.quote;

        if (currentQuestion == ISSUES_INDEX) {
            // This is needed for the Dealer's Wizard so that we calculate the quote before the Quote page is shown
            quote = calculateQuoteAmount(newUserChoices, this.props.data.settings, this.state.configurations);
        }

        this.setState(Immutable.Map(this.state)
            .merge({
                currentQuestion: currentQuestion + 1,
                userChoices: newUserChoices,
                configurations: filterConfigurations(this.state.configurations, newUserChoices),
                quote: quote
            }).toJS()
        );

        this.scrollToWizardNavigation(() => {
            this.swiper.unlockSwipes();
            this.swiper.slideTo(currentQuestion + 1);
            this.swiper.lockSwipes();
        });

        ga('send', 'event', 'Wizard', 'choice-click');
    }

    handleNavigationItemClick(index: number) {
        if (!this.state.isSubmitted) {

            var newUserChoices = Immutable.List(this.state.userChoices).take(index).toJS();

            this.setState(Immutable.Map(this.state)
                .merge({
                    currentQuestion: index,
                    userChoices: newUserChoices,
                    configurations: filterConfigurations(this.props.data.configurations, newUserChoices),
                })
                .toJS()
            );

            this.scrollToWizardNavigation(() => {
                this.swiper.unlockSwipes();
                this.swiper.slideTo(index);
                this.swiper.lockSwipes();
            });

            ga('send', 'event', 'Wizard', 'navigation-click');

        } else {
            // Form is submitted so we don't allow going back any steps
        }
    }

    handleDetailsFormSubmit(data: DetailsFormData) {

        this.setState(
            Immutable.fromJS(this.state)
                .setIn(['detailsData', 'status'], AsyncPostStatus.POSTING)
                .setIn(['detailsData', 'data'], data)
                .toJS()
        );

        var quote = calculateQuoteAmount(this.state.userChoices, this.props.data.settings, this.state.configurations);

        var postData : StoreQuoteData = {
            userChoices: this.state.userChoices,
            userChoicesDict: userChoicesAsDictionary(this.state.userChoices, this.props.data.questions),
            contact: data,
            quote: quote,
            hostname: window.location.hostname,
            feedUrl: this.props.quoteRequestsFeedUrl
        };

        $.ajax({
            type: 'POST',
            url: 'https://t4180mk7s3.execute-api.eu-west-1.amazonaws.com/prod/StoreQuoteRequest-dev',
            //url: 'https://t4180mk7s3.execute-api.eu-west-1.amazonaws.com/dev/CellClinicSubmitForm-dev',
            data: JSON.stringify(postData),
            contentType: "application/json",
            dataType: 'json'
        }).done((resp) => {

            if (resp && resp.key) {

                this.setState(Immutable.Map(this.state)
                    .merge({
                        currentQuestion: this.state.currentQuestion + 1,
                        userChoices: Immutable.List(this.state.userChoices).set(this.state.currentQuestion, 'Entered').toJS(),
                        detailsData: {
                            status: AsyncPostStatus.POSTED,
                            data: data,
                            responseData: resp.key
                        },
                        quote: quote + resp.penalty,
                        quoteNumber: resp.quoteNumber
                    })
                    .toJS()
                );

            } else {
                this.setState(Immutable.Map(this.state)
                    .merge({
                        detailsData: {
                            status: AsyncPostStatus.ERROR,
                            data: data,
                            error: resp.errorMessage
                        }
                    })
                    .toJS()
                );
            }

            this.swiper.unlockSwipes();
            this.swiper.slideNext();
            this.swiper.lockSwipes();

        });

        ga('send', 'event', 'Wizard', 'details-form-submit');

    }

    handleQuoteAccepted(repairQuoteType: EQuoteType) {
        this.setState(Immutable.Map(this.state)
            .merge({
                currentQuestion: this.state.currentQuestion + 1,
                userChoices: Immutable.List(this.state.userChoices).set(this.state.currentQuestion, repairQuoteType).toJS(),
            })
            .toJS()
        );

        this.scrollToWizardNavigation(() => {
            this.swiper.unlockSwipes();
            this.swiper.slideTo(repairQuoteType === EQuoteType.InStoreRepair ? CONFIRMATION_STEP : ADDRESS_FORM_STEP);
            this.swiper.lockSwipes();
        });

        ga('send', 'event', 'Wizard', 'quote-accepted');

    }

    handleReplacementAccepted() {
        this.setState(Immutable.Map(this.state)
            .merge({
                quote:           this.state.configurations[0].replacementPrice,
                currentQuestion: this.state.currentQuestion + 1,
                userChoices:     Immutable.List(this.state.userChoices).set(this.state.currentQuestion, EQuoteType.Replacement).toJS(),
            })
            .toJS()
        );

        this.scrollToWizardNavigation(() => {
            this.swiper.unlockSwipes();
            this.swiper.slideTo(ADDRESS_FORM_STEP);
            this.swiper.lockSwipes();
        });

        ga('send', 'event', 'Wizard', 'replacement-accepted');

    }

    handleEmailQuote() {

        var postData : EmailQuoteData = {
            userChoices: this.state.userChoices,
            userChoicesDict: userChoicesAsDictionary(this.state.userChoices, this.props.data.questions),
            contact: this.state.detailsData.data,
            quote: this.state.quote,
            key: this.state.detailsData.responseData,
            hostname: window.location.hostname,
            quoteNumber: this.state.quoteNumber,
            QUOTE_TYPES:       EQuoteType,
            TRANSFER_DETAILS:  TRANSFER_DETAILS,
            selectedQuoteType: this.state.userChoices[QUOTE_STEP]
        };

        this.setState(
            Immutable.fromJS(this.state)
                .setIn(['sendQuoteByEmail', 'status'], AsyncPostStatus.POSTING)
                .setIn(['sendQuoteByEmail', 'data'], postData)
                .toJS()
        );

        $.ajax({
            type: 'POST',
            url: 'https://t4180mk7s3.execute-api.eu-west-1.amazonaws.com/prod/SendQuoteByEmail-dev',
            data: JSON.stringify(postData),
            contentType: "application/json",
            dataType: 'json'
        }).done( (data) => {

            if (data && data.errorMessage) {
                this.setState(
                    Immutable.fromJS(this.state)
                        .setIn(['sendQuoteByEmail', 'status'], AsyncPostStatus.ERROR)
                        .setIn(['sendQuoteByEmail', 'error'], 'Failed to send email. Please try again.')
                        .toJS()
                );
                this.setState(Immutable.Map(this.state)
                    .merge({
                        sendQuoteByEmail: {
                            status: AsyncPostStatus.POSTED,
                            data: postData
                        }
                    })
                    .toJS()
                );
            }

        });

        ga('send', 'event', 'Wizard', 'email-quote');

    }

    handleSearchTechnician() {
        console.debug('send technician')
    }

    handleAddressFormSubmit(addressData: AddressFormData) {
        this.setState(
            Immutable.fromJS(this.state)
                .setIn(['addressData', 'status'], AsyncPostStatus.POSTING)
                .setIn(['addressData', 'data'], addressData)
                .toJS()
        );

        const postData : StoreWizardData = {
            userChoices:       this.state.userChoices,
            userChoicesDict:   userChoicesAsDictionary(this.state.userChoices, this.props.data.questions),
            contact:           this.state.detailsData.data,
            address:           addressData,
            quote:             this.state.quote,
            hostname:          window.location.hostname,
            feedUrl:           this.props.repairRequestsFeedUrl,
            QUOTE_TYPES:       EQuoteType,
            TRANSFER_DETAILS:  TRANSFER_DETAILS,
            selectedQuoteType: this.state.userChoices[QUOTE_STEP]
        }

        const ticketText = getTicketText(
            this.state.userChoices,
            this.props.data.questions,
            this.state.detailsData.data,
            addressData,
            this.state.quote
        )

        if (this.state.userChoices[QUOTE_STEP] === EQuoteType.Replacement) {
            this.state.userChoices[ISSUES_INDEX] = `Replacement ${this.state.userChoices[CAPACITY_INDEX]} GB`
        } else {
            this.state.userChoices[ISSUES_INDEX] = `${this.state.userChoices[QUOTE_STEP]}: ${this.state.userChoices[ISSUES_INDEX]}`
        }
        /*:first_name, :last_name, :email, :phone, :mobile, :created_at, :updated_at,
         :address, :city, :state, :zip, :ticket_subject, :ticket_description,
         :ticket_problem_type, :ticket_id, :customer_id, :contact_id*/
        const repairShoprLeadsData = {
            api_key: '901e0a8e-d597-45d5-b27c-b0bb78f2dfa3',
            first_name: this.state.detailsData.data.name,
            last_name: this.state.detailsData.data.surname,
            email: this.state.detailsData.data.email,
            phone: this.state.detailsData.data.areaCode + '-' + this.state.detailsData.data.contactNumber,
            address: addressData.streetNumber + ', ' + addressData.streetName,
            city: addressData.city,
            zip: addressData.zipCode,
            ticket_subject: 'Contact using repair wizard',
            ticket_description: ticketText
        };

        $.when(
            $.ajax({
                type: 'POST',
                url: 'https://t4180mk7s3.execute-api.eu-west-1.amazonaws.com/prod/StoreWizardRequest-dev',
                data: JSON.stringify(postData),
                contentType: "application/json",
                dataType: 'json'
            }),
            $.post('http://cellclinic.repairshopr.com/api/v1/leads', repairShoprLeadsData)
        ).always(function(data) {
            this.setState(Immutable.Map(this.state)
                .merge({
                    currentQuestion: this.state.currentQuestion + 1,
                    userChoices: Immutable.List(this.state.userChoices).set(this.state.currentQuestion, 'Submitted').toJS(),
                    isSubmitted: true,
                    addressData: {
                        status: AsyncPostStatus.POSTED,
                        data: data
                    }
                })
                .toJS()
            );

            this.scrollToWizardNavigation(() => {
                this.swiper.unlockSwipes();
                this.swiper.slideNext();
                this.swiper.lockSwipes();
            });

            this.trackConversion();

        }.bind(this));

        ga('send', 'event', 'Wizard', 'address-form-submit');

    }

    handlePrevButtonClick() {
        this.handleNavigationItemClick(this.state.currentQuestion-1);
        ga('send', 'event', 'Wizard', 'back-btn-click');
    }

    scrollToWizardNavigation(callback) {
        var navigation = $(".cc-navigation");
        if ($(window).scrollTop() > navigation.offset().top) {
            $('html, body').animate({
                scrollTop: navigation.offset().top
            }, 300, 'swing', callback);
        } else {
            callback();
        }
    }

    render() {

        var prevButton;

        if (this.state.currentQuestion > 0 && !this.state.isSubmitted) {
            prevButton = <div className="swiper-button-prev" onClick={this.handlePrevButtonClick.bind(this)}></div>;
        }

        var swiper = <div className="swiper-container" ref="swiper">
            <div className="swiper-wrapper">
                {
                    Immutable.List(this.props.data.questions).map((question, index) =>
                        <div className="swiper-slide" key={index}>
                            <Question
                                index={index}
                                question={question}
                                quote={this.state.quote}
                                userChoices={this.state.userChoices}
                                configurations={this.state.configurations}
                                settings={this.props.data.settings}
                                postData={this.state.postData}
                                detailsData={this.state.detailsData}
                                addressData={this.state.addressData}
                                sendQuoteByEmail={this.state.sendQuoteByEmail}
                                onChoice={this.handleChoice.bind(this)}
                                onQuoteAccepted={this.handleQuoteAccepted.bind(this)}
                                onReplacementAccepted={this.handleReplacementAccepted.bind(this)}
                                onEmailQuote={this.handleEmailQuote.bind(this)}
                                onSearchTechnician={this.handleSearchTechnician.bind(this)}
                                onDetailsFormSubmit={this.handleDetailsFormSubmit.bind(this)}
                                onAddressFormSubmit={this.handleAddressFormSubmit.bind(this)}
                            />
                        </div>
                    ).toArray()
                }
                <div className="swiper-slide" key="confirmation">
                    <Confirmation
                        userName={this.state && this.state.detailsData && this.state.detailsData.data ? this.state.detailsData.data.name : ''}
                        quoteType={this.state.userChoices[QUOTE_STEP] as EQuoteType}
                    />
                </div>
            </div>
            {prevButton}
        </div>;

        return <div className="cc-wizard-component">
            <Navigation
                currentQuestion={this.state.currentQuestion}
                userChoices={this.state.userChoices}
                questions={this.props.data.questions}
                onClick={this.handleNavigationItemClick.bind(this)}
            />
            {/*content*/}
            {swiper}
        </div>;
    }
}
